<template>
  <v-row no-gutters class="pt-5 pr-2">
    <v-col v-if="computedIsFetched">
      <card-title-row translation-path="sidebar.tasks" :amount="1" :is-plural="true">
        <template #buttons>
          <base-rounded-button
            v-if="hasPermission"
            icon="mdi-plus"
            size="x-small"
            color="success"
            :tooltip="$i18n.t('button.createTask')"
            @click="toogleTaskAdding"
          />
        </template>
      </card-title-row>
      <card-title-row
        is-subtitle
        translation-path="sidebar.visualisationOnMap"
        :amount="1"
        :is-plural="true"
        class="pt-2"
      />
      <sidebar-row class="pt-2">
        <sidebar-select-row
          translation-path="sidebar.visualizationType"
          font-size="14px"
          @input="handleStyleChange"
          :value="currentStyle"
          :select-props="styleSelectProps"
        />
      </sidebar-row>
      <module-legend ref="moduleLegend" border-bottom module-name="tasks" />
      <card-title-row is-subtitle translation-path="sidebar.summary" :amount="1" :is-plural="true" class="pt-3 pb-3" />
      <sidebar-row>
        <sidebar-summary :items="tasksSummaryItems" class="pt-4 pb-6">
          <template v-for="item of tasksSummaryItems" #[item.name]>
            {{ getItemsLength(item.name) }}
          </template>
        </sidebar-summary>
      </sidebar-row>
      <sidebar-row>
        <sidebar-switcher-filters :filters="tasksFilters" />
      </sidebar-row>
    </v-col>
    <v-col v-else>
      <main-loader />
    </v-col>
  </v-row>
</template>

<script>
import { call, get } from 'vuex-pathify';

import CardTitleRow from '@/components/CardTitleRow';
import SidebarSelectRow from '@/components/SidebarSelectRow';
import SidebarSummary from '@/components/SidebarSummary';
import SidebarSwitcherFilters from '@/components/SidebarSwitcherFilters';
import SidebarRow from '@/components/SidebarRow';
import ModuleLegend from '@/components/ModuleLegend';
import MainLoader from '@/components/MainLoader';

export default {
  name: 'Tasks',
  components: {
    MainLoader,
    ModuleLegend,
    SidebarRow,
    CardTitleRow,
    SidebarSelectRow,
    SidebarSummary,
    SidebarSwitcherFilters,
  },
  data: () => ({
    isFetched: false,
    layersLoaded: false,
  }),
  computed: {
    currentUser: get('users/currentUser'),
    dataSourceName: get('admin/modulesMapping@tasks.datasource_name'),
    permissions: get('users/toolsPermissions'),
    styles: get('styles/styles@:dataSourceName'),
    tasks: get('tasks/tasks'),
    tasksStatuses: get('admin/modulesMapping@tasks.statuses'),
    currentStyle: get('styles/currentStyle@:dataSourceName'),
    defaultStyle: get('styles/defaultStyle@:dataSourceName'),
    loaded: get('modules/loaded@:dataSourceName'),

    computedIsFetched() {
      return this.isFetched && this.loaded;
    },
    hasPermission() {
      return this.permissionsTasks.main_value > 1;
    },
    permissionsTasks() {
      return this.permissions['TASKS'];
    },
    computedSelectStyles() {
      return [this.defaultStyle, ...this.$_sortObjectsByAttribute([...this.styles], 'name')];
    },
    styleSelectProps() {
      return {
        items: this.computedSelectStyles,
        itemText: 'name',
        itemValue: 'id',
        returnObject: true,
      };
    },
    tasksSummaryItems() {
      return [
        {
          name: 'new',
          straightText: this.tasksStatuses['new'],
          color: 'rgba(0,145,234)',
        },
        {
          name: 'planned',
          straightText: this.tasksStatuses['planned'],
          color: 'rgba(108,108,108)',
        },
        {
          name: 'in_progress',
          straightText: this.tasksStatuses['in_progress'],
          color: 'rgba(255,136,0)',
        },
        {
          name: 'done',
          straightText: this.tasksStatuses['done'],
          color: 'rgba(24,128,56)',
        },
      ];
    },
    tasksFilters() {
      return [
        {
          name: 'myTasks',
          translationPath: 'dialog.showMyTasks',
          filter: {
            assigned_user: [this.currentUser.id],
          },
          emptyFilter: {
            assigned_user: [],
          },
        },
      ];
    },
  },
  methods: {
    getStyles: call('styles/getStyles'),
    getTasks: call('tasks/getTasks'),
    setCurrentStyle: call('styles/setCurrentStyle'),
    getItemsLength(name) {
      const translateName = this.tasksStatuses[name];
      return this.$_objectToArray(this.tasks).filter(task => task.status === translateName).length;
    },
    toogleTaskAdding() {
      this.$router.push({
        name: 'task',
        params: { fid: 'new' },
      });
    },
    async handleStyleChange(style) {
      await this.setCurrentStyle({ dataSource: this.dataSourceName, style: style });
      this.$root.$emit('tasksStyleChanged', style);
      await this.$refs.moduleLegend.getModuleStyle();
    },
    async init() {
      await Promise.all([this.getTasks(), this.getStyles(this.dataSourceName)]);
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.divider-row {
  @include border(bottom);
}
</style>
